@let localVideos = vrVideos(); @let local360 = vr360();

<div class="col-12">
  <div class="d-flex flex-wrap justify-content-center align-items-center gap-1 mb-2">
    <img class="me-1" src="img/icons/ra_icon_circle.png" height="28" />
    <h3 class="dark-blue-text text-shadow-white fs-3 text-center">
      {{ 'contenido_realidad_virtual' | translate | capitalize }}
    </h3>
  </div>

  <p class="text-center">
    {{ 'geomarker.descripcion_vr' | translate }}
  </p>
</div>

@if (localVideos?.length || local360?.length) {
  <div class="col-12">
    <app-carousel-vr [vrMedia]="vrMedia()" />
  </div>
}
